import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material";
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { PlanService } from "../shared/services/planService";

@Component({
  selector: 'app-plan-upgrage-dialog',
  templateUrl: './plan-upgrage-dialog.component.html',
  styleUrls: ['./plan-upgrage-dialog.component.css']
})
export class PlanUpgrageDialogComponent implements OnInit {

  currentPlan;
  freePlan;
  constructor(private dialogRef: MatDialogRef<PlanUpgrageDialogComponent>, private restApiService: RestApiService, private router: Router, private planService: PlanService) {
  }

  ngOnInit() {
    this.restApiService.getCurrentPlanAndFreePlanDetails().subscribe(res => {
      if (res.success) {
        if (res.currentPlan) {
          this.currentPlan = res.currentPlan
        }
        if (res.freePlan) {
          this.freePlan = res.freePlan;
        }
      }
    });
  }

  OnFreePlan() {
    if (this.freePlan && this.currentPlan) {
      this.restApiService.changePlan(this.currentPlan['superAdminID'], this.freePlan).subscribe(res => {
        if (res && res.success == true) {
          this.planService.setSubscription(res["sub_ID"]);
          this.planService.setOldSubscription(res["subscription_id"]);
          this.dialogRef.close();
        }
      });
    }
  }

  goToPricingPage() {
    this.router.navigateByUrl('/pricing');
    this.dialogRef.close();
  }

  goToCheckOutPage() {
    this.planService.setPlan(this.currentPlan);
    var superAdminID = localStorage.getItem("superAdminID");
    this.restApiService.changePlan(superAdminID, this.currentPlan).subscribe(res => {
      if (res && res.success == true) {
        if (res.freePlan) {
          this.dialogRef.close();
        }
        else {
          this.planService.setSubscription(res["sub_ID"]);
          this.planService.setOldSubscription(res["subscription_id"]);
          this.dialogRef.close();
          this.router.navigateByUrl('/checkout');
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/plan-upgrage-dialog/plan-upgrage-dialog.component.ts